import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { AuthLayout, Field } from './Signup';

export default function UserLogin() {
  const [params] = useSearchParams();
  const linkErr = params.get('error');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    setBusy(true); setErr(null);
    try {
      await api.requestMagicLink(email);
      setSent(true);
    } catch (e: any) {
      setErr(e?.message || 'Could not send link. Try again.');
    } finally { setBusy(false); }
  }

  if (sent) {
    return (
      <AuthLayout
        title="Check your inbox"
        sub={`We sent a sign-in link to ${email}. It's valid for 15 minutes.`}
        footer={<>New to Sendepot? <Link to="/signup" className="text-accent hover:underline">Create an account</Link></>}
      >
        <p className="text-xs text-dim leading-relaxed">
          Didn't get it? Check your spam folder, or{' '}
          <button onClick={() => setSent(false)} className="text-accent hover:underline">
            request a new link
          </button>.
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Sign in to Sendepot"
      sub="Enter your email — we'll send you a sign-in link."
      footer={<>New to Sendepot? <Link to="/signup" className="text-accent hover:underline">Create an account</Link></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <Field
          label="Email" type="email" required autoComplete="email"
          value={email} onChange={setEmail}
          placeholder="you@company.com"
        />
        {linkErr === 'invalid' && !err && (
          <div className="text-warn text-xs flex items-start gap-1.5">
            <span className="dot dot-warn mt-1" />
            That sign-in link is invalid or has expired. Request a new one.
          </div>
        )}
        {err && (
          <div className="text-err text-xs flex items-center gap-1.5">
            <span className="dot dot-err" />{err}
          </div>
        )}
        <button disabled={busy || !email} className="btn-primary btn-lg w-full">
          {busy ? 'Sending…' : 'Email me a sign-in link'}
        </button>
      </form>

      <div className="mt-6 pt-4 border-t border-line text-center">
        <Link to="/admin" className="text-[11px] text-dim hover:text-ink transition">
          Operator break-glass login →
        </Link>
      </div>
    </AuthLayout>
  );
}
